"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function RequestEpcCertificate() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative min-h-[600px] w-full overflow-hidden bg-dark-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/dutch_neighbourhood_aerial_view.png)",
      transform: isVisible ? "translateY(0)" : "translateY(-5%)",
      transition: "transform 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94)"
    }}>
        {}
        <div className="absolute inset-0 bg-dark-background/45"></div>
      </div>

      {}
      <div className="relative z-10 flex min-h-[600px] items-center justify-center px-4 py-24 sm:px-6 lg:px-8">
        <div className={`flex max-w-3xl flex-col items-center text-center transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          {}
          <h1 className="mb-4 text-4xl font-bold leading-tight text-foreground-dark sm:text-5xl lg:text-6xl">
            EPC-keuring snel en eenvoudig aanvragen
          </h1>

          {}
          <h2 className="mb-8 text-xl font-semibold leading-snug text-foreground-dark/90 sm:text-2xl">Gecertificeerde EPC attesten voor uw woning of gebouw</h2>

          {}
          <Link to="/ContactPage">
            <Button size="lg" className="group mb-4 bg-primary px-8 py-4 text-base font-semibold text-foreground-primary shadow-medium transition-all duration-[120ms] ease-in-out hover:scale-[1.04] hover:bg-primary-hover hover:shadow-strong focus-visible:ring-2 focus-visible:ring-primary/40">
              Keuring in 1 minuut aanvragen
            </Button>
          </Link>

          {}
          <p className="text-sm text-foreground-dark/75">
            Of bel ons direct op{" "}
            <Link to="tel:+3221234567" className="underline underline-offset-2 transition-colors hover:text-secondary">0487412206</Link>
          </p>
        </div>
      </div>
    </section>;
}